import { useEffect, useState } from 'react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Helper to get cookie preferences
const getCookiePreferences = () => {
  try {
    const prefs = localStorage.getItem('cookiePreferences');
    return prefs ? JSON.parse(prefs) : null;
  } catch {
    return null;
  }
};

// Helper to check if marketing is allowed
const isMarketingAllowed = () => {
  const prefs = getCookiePreferences();
  return prefs?.marketing === true;
};

export const MetaPixel = () => {
  const [pixelId, setPixelId] = useState('');
  const [loaded, setLoaded] = useState(false);

  // Fetch Pixel ID from backend
  useEffect(() => {
    const fetchPixelId = async () => {
      try {
        const res = await fetch(`${API_URL}/api/analytics-config`);
        if (res.ok) {
          const data = await res.json();
          if (data.meta_pixel_id) {
            setPixelId(data.meta_pixel_id);
          }
        }
      } catch (err) {
        console.error('Failed to fetch pixel config:', err);
      }
    };
    fetchPixelId();
  }, []);

  // Load Meta Pixel script only when marketing is allowed and we have a Pixel ID
  useEffect(() => {
    if (!pixelId || loaded) return;

    // Check if marketing cookies are allowed
    if (!isMarketingAllowed()) {
      console.log('Marketing cookies not accepted - Meta Pixel not loaded');
      return;
    }

    // Load Meta Pixel
    const loadPixel = () => {
      // Meta Pixel base code
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      
      window.fbq('init', pixelId);
      window.fbq('track', 'PageView');

      setLoaded(true);
      console.log('Meta Pixel loaded:', pixelId);
    };

    loadPixel();
  }, [pixelId, loaded]);

  // Listen for cookie preference changes
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'cookiePreferences') {
        window.location.reload();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return null;
};

export default MetaPixel;
